import { motion } from "framer-motion";
import { ArrowUpRight, PenLine, MessagesSquare, BadgeCheck } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const STEPS = [
  {
    n: "01", icon: PenLine, title: "Tell us",
    text: "Send the enquiry below — the program you're drawn to, and where you're starting from. That's all we need to begin.",
    note: "FIVE MINUTES",
  },
  {
    n: "02", icon: MessagesSquare, title: "The call",
    text: "A relaxed counselling call with the LIMA team — your goals, batch fit, a curriculum walkthrough and the exact fee structure.",
    note: "NO PRESSURE",
  },
  {
    n: "03", icon: BadgeCheck, title: "Enrol",
    text: "Confirm your seat. Fees are shared on the call — EMI plans available, with scholarships set aside for standout applicants.",
    note: "15 SEATS ONLY",
  },
];

export default function AdmissionsSection() {
  return (
    <section className="bg-lima-cream text-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-black/10" data-testid="admissions-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-20">
        <div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.98]">
            Three steps to <span className="font-serifit font-normal text-[#3a3a36]">your first set.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm text-black/55 leading-relaxed">
          Batch 01 is forming now — we keep cohorts at fifteen so nobody trains from the back row.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-px bg-black/15 border border-black/15">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="bg-lima-cream p-8 md:p-10 flex flex-col"
            data-testid={`admission-step-${s.n}`}
          >
            <div className="flex items-start justify-between mb-8">
              <span className="font-serifd text-5xl text-lima-blue leading-none">{s.n}</span>
              <s.icon size={20} className="text-black/40" />
            </div>
            <h3 className="font-display font-bold text-2xl tracking-tight mb-3">{s.title}</h3>
            <p className="text-sm text-black/60 leading-relaxed flex-1">{s.text}</p>
            <p className="mt-6 pt-4 border-t border-black/10 font-mono2 text-[11px] tracking-[0.2em] text-black/45">{s.note}</p>
          </motion.div>
        ))}
      </div>
      <motion.button
        whileTap={{ scale: 0.96 }}
        onClick={() => scrollToId("#contact")}
        data-testid="admissions-apply-button"
        className="mt-10 bg-lima-blue hover:bg-lima-bluehover text-white font-mono2 text-xs font-bold tracking-[0.2em] px-8 py-4 transition-colors duration-200 inline-flex items-center gap-3"
      >
        START WITH THE ENQUIRY FORM <ArrowUpRight size={15} />
      </motion.button>
    </section>
  );
}
